"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("document-browser");
function explicitHeightStyle(props) {
  if (props.tmsObjects.length > 5) {
    return { height: 185 };
  } else {
    return {};
  }
}
export default function DropSelector(props) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: bem("__assign-documents-selector"),
      style: explicitHeightStyle(props),
      children: [
        /* @__PURE__ */ jsx("span", { className: bem("__assign-documents-selector-label"), children: props.label }),
        _.map(props.tmsObjects, props.tmsObjectDetailsFunction)
      ]
    }
  );
}
